export default "__VITE_ASSET__BnbIGFgg__"